<template>
  <div>
    <div class="matches-container">
      <!-- <div class="live-scores-title">Live Matches</div> -->

      <div
        class="matches"
        v-if="liveMatchesData != null && liveMatchesData.length > 0"
      >
        <div
          class="match"
          @click="selectMatch(match)"
          v-for="(match, index) in liveMatchesData"
          v-bind:key="index"
          v-bind:class="{ selected: matchId == match.matchID }"
        >
          <div class="match-inner glow-border">
            <div class="court-id">
              {{ match.courtName }}&nbsp;{{ match.roundName }}
            </div>

            <div
              class="player-stats"
              :class="{ highlight: matchId == match.matchID }"
            >
              <div class="player-name">
                {{ match.player1Name }}
                <span v-if="match.seed1 && match.seed1 !== '0' && !match.player1Name.includes('/')" class="seed">
                  [{{ match.seed1 }}]
                </span>
              </div>

              <div class="sets-stats">
                <div class="set" v-if="match.Sets[0]">
                  {{ match.Sets[0].player1Games }}
                </div>
                <div class="set" v-else>-</div>
                <div class="set" v-if="match.Sets[1]">
                  {{ match.Sets[1].player1Games }}
                </div>
                <div class="set" v-else>-</div>
                <div class="set" v-if="match.Sets[2]">
                  {{ match.Sets[2].player1Games }}
                </div>
                <div class="set" v-else>-</div>
              </div>
            </div>

            <div
              class="player-stats"
              :class="{ highlight: matchId == match.matchID }"
            >
              <div class="player-name">
                {{ match.player2Name }}
                <span v-if="match.seed2 && match.seed2 !== '0' && !match.player2Name.includes('/')" class="seed">
                  [{{ match.seed2 }}]
                </span>
              </div>
              <div class="sets-stats">
                <div class="set" v-if="match.Sets[0]">
                  {{ match.Sets[0].player2Games }}
                </div>
                <div class="set" v-else>-</div>
                <div class="set" v-if="match.Sets[1]">
                  {{ match.Sets[1].player2Games }}
                </div>
                <div class="set" v-else>-</div>
                <div class="set" v-if="match.Sets[2]">
                  {{ match.Sets[2].player2Games }}
                </div>
                <div class="set" v-else>-</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>NO MATCHES AVAILABLE</div>
    </div>

    <!-- MATCH STATS COMPONENT-->
    <match-stats
      v-if="matchId"
      v-bind:match-id="matchId"
      v-bind:tournament-id="tournamentId"
    ></match-stats>
  </div>
</template>

<script>
import MatchStats from "./MatchStats.vue";

export default {
  name: "LiveMatches",
  props: {
    tournamentId: String,
  },
 data: () => ({
  matchId: null,
  refreshKey: 0 
}),
  components: {
    "match-stats": MatchStats,
  },

  methods: {
    selectMatch(match) {
      this.matchId = match.matchID;
      this.$store.dispatch("setMatchId", match.matchID);
      //this.selectedMatchData = match;
      // this.$store.dispatch("setMatchData", this.selectedMatchData);
      console.log("LiveMatches: selectMatch() matchId = " + match.matchID);
      //console.log("LiveMatches: selectedMatchData = " + this.selectedMatchData);
    },
  },

  computed: {
   liveMatchesData: function () {
  this.refreshKey; // 👈 triggers reactivity

  const matches = this.$store.getters.matches(this.tournamentId, "False");
  if (matches) {
    return matches;
  } else {
    console.log("liveMatchesData DATA = NULL");
    return [];
  }
}
  },

 mounted() {
  this.$store.dispatch("setCurrentScreen", "live-match-select");

  setInterval(() => {
    this.refreshKey++;
  }, 5000); // refresh every 5 seconds
}
};
</script>

<style scoped>
/* .live-scores-title {
  font-size: 2rem;
} */

.matches-container {
  padding: 1rem 0.5em;
}

.matches {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-family: "GeneralSans SemiBold";
  font-family: 26px;
}

.match {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  padding: 0.25rem;
  min-width: 45%;
  margin: 0.25rem;
  visibility: hidden;
  border-radius: 0.5rem;

  cursor: pointer;
}

.match.selected {
  visibility: visible;
}

.match-inner {
  width: 100%;
  background-color: #000000;
  text-align: left;
  font-weight: 400;
  cursor: pointer;
  font-size: 1.5rem;
  visibility: visible;
}

.court-id {
  background-color: #000000;
  color: #fff;
  display: flex;
  justify-content: center;
  font-size: 22px;
}
.player-stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white; /* White background */
  border-radius: 12px; /* Slightly rounded corners */
  color: #4b006e; /* Dark purple text */
  text-transform: uppercase; /* Capitalize names */
  margin-bottom: 8px;
}
.player-stats.highlight {
  background: linear-gradient(to right, #01d16d, #00edc9);
  color: #4b006e;
}

.player-name {
  flex-grow: 1; /* Allows the name to take up available space */
  text-align: left;
  padding-left: 10px;
}

.sets-stats {
  display: flex;
  gap: 12px; /* Adjust spacing between numbers */
}

.set {
  padding: 4px 8px;
  min-width: 22px;
  text-align: center;
  font-weight: bold;
  font-size: 1.2em; /* Bigger numbers */
  color: #4b006e; /* Dark purple */
}
.seed {
  font-size: 12px;
  position: relative;
  top: -3px; /* Adjust this value to move it lower */
  letter-spacing: 2px; /* Adds space between characters */
}
</style>
